import { OrderNote } from '@vindr/services/apis/order.api';
import { Empty } from '@vindr/ui';
import dayjs from '@vindr/utils/day';
import { getDateFormatted } from '@vindr/utils/helpers/common.helper';
import { Button, Input, Modal, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const OrderNoteModal = ({
  orderNotes,
  onSaveNewNote,
  open,
  onClose,
}: {
  orderNotes: OrderNote[];
  onSaveNewNote: (note: string) => void;
  open: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation('Vindoc');

  const [newNoteText, setNewNoteText] = useState<string>('');

  const notesText = useMemo(() => {
    if (!orderNotes) return '';

    return orderNotes
      .slice()
      .sort((a, b) => dayjs(b.time).valueOf() - dayjs(a.time).valueOf())
      .map((note) => {
        const name = note?.user || '';
        const formattedDate = dayjs(note?.time).format(getDateFormatted(true)) || '';
        return `${formattedDate} - (${name}): ${note?.text}`;
      })
      .join('\n\n');
  }, [orderNotes]);

  const handleSave = () => {
    onSaveNewNote(newNoteText);
    setNewNoteText('');
  };

  return (
    <Modal
      title={t('Note')}
      open={open}
      onCancel={onClose}
      footer={null}
      width={800}
      forceRender
      destroyOnClose
    >
      {orderNotes?.length ? (
        <Input.TextArea
          value={notesText || ''}
          rows={orderNotes?.length * 2}
          readOnly
          style={{ resize: 'none', maxHeight: 200, overflowY: 'auto' }}
        />
      ) : (
        <Empty description={t('No notes')} />
      )}
      <Input.TextArea
        value={newNoteText}
        onChange={(e) => setNewNoteText(e.target.value)}
        placeholder={t('Add new note')}
        rows={3}
        style={{ marginTop: 16, maxHeight: 100, overflowY: 'auto' }}
      />
      <Space style={{ marginTop: 16, display: 'flex', justifyContent: 'flex-end' }}>
        <Button onClick={onClose}>{t('Cancel')}</Button>
        <Button type="primary" onClick={handleSave} disabled={!newNoteText.trim()}>
          {t('Save')}
        </Button>
      </Space>
    </Modal>
  );
};

export default OrderNoteModal;
